module.exports = __webpack_public_path__ + "img/beer_id-58.ecfbb5a1.png";